import { env } from '@/env'

export const isPR = !!env.NEXT_PUBLIC_SST_STAGE?.startsWith('pr-')

type ClientEnvConfig = {
  key: string
  apiBaseUrl: string
}

const staging: ClientEnvConfig = {
  key: 'staging',
  apiBaseUrl: 'https://admin.staging.stogo.com',
}

const production: ClientEnvConfig = {
  key: 'production',
  apiBaseUrl: 'https://prod-api.stogo.com',
}

const demo: ClientEnvConfig = {
  key: 'demo',
  apiBaseUrl: 'https://demo-api.stogo.com',
}

export const envConfigs = {
  staging,
  production,
  demo,
  pr: staging,
  local: staging,
} as Record<string, ClientEnvConfig>

export const configKey =
  (env.NEXT_PUBLIC_SST_STAGE && envConfigs[env.NEXT_PUBLIC_SST_STAGE]?.key) ||
  (isPR ? 'staging' : '')

const apiBaseUrl =
  env.NEXT_PUBLIC_API_URL || (configKey ? envConfigs[configKey]?.apiBaseUrl || '' : '')
export const passwordResetUrl = `${apiBaseUrl}/accounts/password_reset/`
